module.exports = __webpack_public_path__ + "assets/game-type-word-stress.78476a92.svg";